

const SigningType = {
  EMBEDDED_SIGNING: "EMBEDDED_SIGNING",
  EMAIL_SIGNING: "EMAIL_SIGNING",
};

const EnvelopeStatus = {
  SENT: "sent",
  COMPLETED: "completed",
}

const ProxyDocumentDelivery = {
  // Document is emailed to user
  MAIL_OUT: "mail_out",

  // Document has already been signed
  SIGNED: "signed",

  // There is no signature
  NO_ENVELOPE: "no_envelope",
}

export { SigningType, EnvelopeStatus, ProxyDocumentDelivery };
